module.exports = __webpack_public_path__ + "318ee20bc3ab288eaaff82768d2f883b.woff2";